import { API_URL } from '../config';

import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields } from 'better-auth/client/plugins';

/**
 * Клиент Better Auth.
 *
 * Официальный клиент, а не ручные fetch: он держит форму запросов и ответов
 * синхронной с сервером, сам ходит с credentials и отдаёт типы из конфигурации
 * сервера. Ручные запросы разъехались бы с сервером при первом же обновлении
 * библиотеки, и заметили бы это в проде.
 */
export const authClient = createAuthClient({
  baseURL: API_URL,

  plugins: [
    // Дополнительные поля пользователя объявлены на сервере
    // (apps/server/src/auth/auth.ts). Здесь они перечислены явно, а не выведены
    // через `typeof auth`: dashboard не зависит от пакета сервера и не должен -
    // иначе клиентский бандл начнёт тянуть Prisma по цепочке типов.
    // Расхождение ловится тестами контура, а не типами.
    inferAdditionalFields({
      user: {
        timezone: { type: 'string' },
        // input: false повторяет серверное объявление: тариф пользователь себе
        // не назначает, и в форму регистрации это поле попадать не должно.
        planId: { type: 'string', input: false },
      },
    }),
  ],

  fetchOptions: {
    // Сессия ездит в httpOnly-cookie между поддоменами app и api.
    credentials: 'include',
  },
});

/**
 * Реэкспортируются только те методы, чей выведенный тип называется без ссылки
 * на внутренние типы библиотеки. `signUp` в их число не входит: из-за
 * дополнительных полей пользователя его тип ссылается на внутренний
 * InferSignUpEmailCtx, и объявить его здесь без аннотации нельзя. Экраны
 * вызывают его через authClient напрямую.
 */
export const signIn = authClient.signIn;
export const signOut = authClient.signOut;
export const useSession = authClient.useSession;
/** Смена пароля: текущий, новый, выход с других устройств. */
export const changePassword = authClient.changePassword;

/** Базовый адрес api - нужен и запросам мимо Better Auth (overlay-токен). */
export const apiUrl = (path: string): string => `${API_URL}${path}`;
